import { useState } from "react";
import { Dropdown } from "react-bootstrap";
import "./styles/CryptoDropdown.css";
import { Icons } from "../assets/icons/Icons";

const CryptoDropdown = ({ onSelect, label, options }) => {
    const [selected, setSelected] = useState({
        id: "btc",
        name: "BTC",
        icon: <Icons.FaBitcoin />,
    });

    const cryptoOptions = options ?? [
        { id: "btc", name: "BTC", icon: <Icons.FaBitcoin /> },
        { id: "usdt", name: "USDT", icon: <Icons.SiTether /> },
        { id: "eth", name: "ETH", icon: <Icons.FaEthereum /> },
        { id: "bnb", name: "BNB", icon: <Icons.SiBinance /> },
    ];

    const handleSelect = (crypto) => {
        setSelected(crypto);
        if (onSelect) {
            onSelect(crypto);
        }
    };

    return (
        <div>
            {label && (
                <label
                    className="font-11 font-700 pt-2"
                    style={{ color: "#797373" }}
                >
                    {label}
                </label>
            )}
            <Dropdown className="crypto-dropdown">
                <Dropdown.Toggle variant="dark" id="dropdown-crypto">
                    <span className="crypto-icon">{selected.icon}</span>
                    <span className="crypto-name">{selected.name}</span>
                </Dropdown.Toggle>

                <Dropdown.Menu>
                    {cryptoOptions.map((crypto) => (
                        <Dropdown.Item
                            key={crypto.id}
                            onClick={() => handleSelect(crypto)}
                            className="crypto-item"
                        >
                            <span className="crypto-icon">{crypto.icon}</span>
                            <span className="crypto-name">{crypto.name}</span>
                        </Dropdown.Item>
                    ))}
                </Dropdown.Menu>
            </Dropdown>
        </div>
    );
};

export default CryptoDropdown;
